import type { LocaleCode } from "~/types";

type Family = 'Gotham' | 'Rubik';
const LOCALE_TO_FONT: Record<LocaleCode, Family> = {
  en: 'Rubik',
  ru: 'Rubik',
  sv: 'Rubik',
  he: 'Rubik',
  'ru-KZ': 'Rubik'
};

export function getFontFamily(locale: LocaleCode) {
  return LOCALE_TO_FONT[locale];
}